import React from 'react';

import styled from 'styled-components';
import { useAtomValue } from 'jotai';
import { useImmerAtom } from 'jotai-immer';

import { Form, Radio } from 'antd';

import * as Constants from '../../views/diagnosis/constants';
import { isEdemaOrAscitesAtom, cancerAtom } from './atom';
import { useHandleEventValue } from './hooks';

const EdemaOrAscites = ({ getFieldDecorator, radioButtonMessage }) => {
  const [, setDiabetes] = useImmerAtom(cancerAtom);
  const handleChangeValue = useHandleEventValue({ setImmerState: setDiabetes });
  const isEdemaOrAscites = useAtomValue(isEdemaOrAscitesAtom);
  if (!isEdemaOrAscites) return null;
  return (
    <Form.Item>
      {getFieldDecorator('edemaOrAscites', {
        initialValue: '',
        rules: [
          {
            message: radioButtonMessage
          }
        ]
      })(
        <CheckDiagnosisSection>
          <SubQueryTitle>
            <b>부종</b> 또는 <b>복수</b>의 증상이 있으신가요?
          </SubQueryTitle>
          <Radio.Group buttonStyle="solid">
            {Constants.YES_OR_NO.map(item => {
              const { name, value } = item;
              return (
                <SelectBox key={value} onClick={handleChangeValue('edemaOrAscites')} value={value}>
                  {name}
                </SelectBox>
              );
            })}
          </Radio.Group>
        </CheckDiagnosisSection>
      )}
    </Form.Item>
  );
};

export default EdemaOrAscites;

const RelayionTypeSection = styled.div`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child) {
    font-size: 1.8rem;
    ${props => props.theme.device.md} {
      font-size: 2.4rem;
    }
  }
`;

const CheckDiagnosisSection = styled(RelayionTypeSection)``;

const SubQueryTitle = styled.div`
  word-break: keep-all;
  font-size: 1.5rem;
  font-weight: 400;
  color: #323232;
  margin-bottom: ${props => (props.isText ? '0' : '2rem')};

  ${props => props.theme.device.md} {
    font-size: 2rem;
  }
`;
const SelectBox = styled(Radio.Button)`
  height: 6rem;
  word-break: keep-all;
  margin: 0.5rem 0;
  width: calc(50% - 1.6rem);
  line-height: ${props => (props.lineHight ? '4rem' : '6rem')};
  span {
    font-size: 1.6rem;
  }
  ${props => props.theme.device.md} {
    height: 7.2rem;
    line-height: ${props => (props.lineHight ? '6.5rem' : '7.2rem')};
    span {
      font-size: 2.4rem;
      word-break: keep-all;
    }
  }
`;
